import constants from '../../constants';
import defaultTheme from './defaultTheme';
export default {
  ...defaultTheme,
  messageHeader: constants.Colors.GreyBlue2,
  messageText: constants.Colors.White,
  tryAgainText: constants.Colors.White,
  tryAgainButton: constants.Colors.Blue,
  infoCircleIcon: constants.Colors.Dusk
};
